import { render, staticRenderFns } from "./ProductListLoader.vue?vue&type=template&id=6b3f3e10"
import script from "./ProductListLoader.vue?vue&type=script&lang=js"
export * from "./ProductListLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports